import { useMutation } from '@apollo/client';

import {
  RemoveFromWishlistMutation,
  RemoveFromWishlistMutationVariables,
} from '@notino/shared/definitions/types';

import removeFromWishlistMutation from '@components/Universals/WishlistModifier/queries/removeFromWishlist.graphql';
import { publishUpdateWishlistCountEvent } from '@components/Universals/WishlistModifier/useWishlistActions';

export const useRemoveNullWishlistProducts = (isEnabled: boolean) => {
  const [remove] = useMutation<
    RemoveFromWishlistMutation,
    RemoveFromWishlistMutationVariables
  >(removeFromWishlistMutation);

  return (nullIds: string[]) => {
    if (!isEnabled || nullIds.length === 0) return;

    const callApi = async () => {
      const promises = nullIds.map((id) =>
        remove({ variables: { productId: id } })
      );
      await Promise.all(promises);
    };

    callApi().finally(publishUpdateWishlistCountEvent);
  };
};
